import { User } from '../types/User';

export const isEnabledRegularUser = (user: User | any): boolean => {
  const isRegular = user?.isRegular === true || user?.is_regular === true;
  const isDisabled = Boolean(
    user?.isDisabled ??
      user?.isDisbaled ??
      user?.is_disabled ??
      user?.is_disbaled
  );
  return isRegular && !isDisabled;
};

export const filterEnabledRegularUsers = (users: Array<User | any>): User[] => {
  return (Array.isArray(users) ? users : []).filter(isEnabledRegularUser);
};
